export const HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const HEADERS_FORM_DATA = {
  "Content-Type": "multipart/form-data",
  Accept: "multipart/form-data",
};
